// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.options-download-modal {
    position: relative;
    max-width: 100%;
    width: 250px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    top: 50%;
    max-height: 100%;

    & > .close-icon-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        & > span {
            margin-inline-start: 10px;
        }

        & .close-icon {
            position: unset;
        }
    }
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/custom-download-options.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,QAAQ;IACR,gBAAgB;;IAEhB;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,8BAA8B;;QAE9B;YACI,yBAAyB;QAC7B;;QAEA;YACI,eAAe;QACnB;IACJ;AACJ","sourcesContent":[".options-download-modal {\n    position: relative;\n    max-width: 100%;\n    width: 250px;\n    position: absolute;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 100%;\n    top: 50%;\n    max-height: 100%;\n\n    & > .close-icon-container {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        & > span {\n            margin-inline-start: 10px;\n        }\n\n        & .close-icon {\n            position: unset;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
